<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t('$vuetify.map.criticalPopup.rejectDialog.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select v-model="rejectReason" :disabled="isApproved"
                  :placeholder="$vuetify.lang.t('$vuetify.map.criticalPopup.rejectDialog.noneSelected')"
                  :items="items" :error-messages="rejectStateError ? rejectErrors : []">
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title v-html="data.item.text"></v-list-item-title>
              <v-list-item-subtitle v-html="data.item.help"></v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-select>
        <v-scroll-y-transition leave-absolute hide-on-leave>
          <retrain-states v-if="isRetrainState" ref="rejectedRetrainStates"
                          :label="$vuetify.lang.t('$vuetify.map.criticalPopup.rejectDialog.retrainLabel')"
                          @state-changed="changeRetrainState"
                          :is-state-empty="retrainStateError">
          </retrain-states>
        </v-scroll-y-transition>
        <v-textarea v-model="rejectComment" auto-grow outlined rows="3"
                    :label="$vuetify.lang.t('$vuetify.map.criticalPopup.rejectDialog.rejectComment')"></v-textarea>
      </v-card-text>
      <v-card-actions class="px-5">
        <v-spacer></v-spacer>
        <v-btn text @click="sendRejectState">{{ $vuetify.lang.t('$vuetify.map.criticalPopup.buttons.confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vuetify from '../../../../plugins/vuetify'

import { mdiClose } from '@mdi/js'
import { UserCriticalEventRejection } from '../../../../enum'
import RetrainStates from './retrainStates'

export default {
  name: 'rejectDialog',
  components: { RetrainStates },
  props: {
    dialog: Boolean,
    isApproved: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      rejectReason: !this.isApproved ? null : UserCriticalEventRejection.RETRAIN,
      rejectComment: null,
      retrainState: null,
      rejectStateError: false,
      retrainStateError: false,

      closeIcon: mdiClose
    }
  },
  computed: {
    items () {
      return Object.values(UserCriticalEventRejection).map(item => ({
        value: item,
        text: Vuetify.framework.lang.t(`$vuetify.map.criticalPopup.rejectDialog.states.${item}`),
        help: Vuetify.framework.lang.t(`$vuetify.map.criticalPopup.rejectDialog.help.${item}`)
      }))
    },
    isRetrainState () {
      return this.rejectReason === UserCriticalEventRejection.RETRAIN
    },
    rejectErrors () {
      return [Vuetify.framework.lang.t(`$vuetify.map.criticalPopup.rejectDialog.emptyStateError`)]
    }
  },
  methods: {
    changeRetrainState (value) {
      this.retrainState = value
      this.retrainStateError = false
    },
    closeDialog () {
      if (!this.isApproved) {
        this.rejectReason = null
      }

      this.rejectComment = null
      this.retrainState = null

      if (this.$refs.hasOwnProperty('rejectedRetrainStates') && this.$refs.rejectedRetrainStates) {
        this.$refs.rejectedRetrainStates.resetForm()
      }

      this.$emit('close-reject-dialog')
    },
    sendRejectState (value) {
      if (!this.rejectReason) {
        this.rejectStateError = true
        return
      }

      if (!this.retrainState && this.isRetrainState) {
        this.retrainStateError = true
      }

      if (!this.rejectStateError && !this.retrainStateError) {
        // can work
        this.$emit('reject-state', {
          rejectReason: this.rejectReason,
          rejectComment: this.rejectComment,
          retrainState: this.isRetrainState ? this.retrainState : null
        })

        this.closeDialog()
      }
    }
  },
  watch: {
    rejectReason (value) {
      if (value !== UserCriticalEventRejection.RETRAIN && this.retrainState) {
        this.retrainState = null
      }

      this.rejectStateError = false
      this.retrainStateError = false
    }
  }
}
</script>

<style scoped>

</style>
